import { Expose, Transform } from 'class-transformer';
import { IsEnum, IsString } from 'class-validator';

export enum LockerVendor {
  EntregaAli = 'entrega_ali',
  MeuLocker = 'meu_locker',
  CliqueRetire = 'clique_retire',
}

// TODO: should insert created and updated fields
// to do this must update api's locker resource
export class Locker {
  @IsString()
  readonly id: string;

  @IsString()
  @Expose({ name: 'condominium_id' })
  readonly condominiumId: string;

  @IsString()
  @Expose({ name: 'locker_id' })
  readonly lockerId: string;

  @IsEnum(LockerVendor)
  /** Should normalize old register */
  @Transform(({ value }) => value ?? LockerVendor.EntregaAli)
  readonly vendor: LockerVendor;

  constructor(init?: Locker | Partial<Locker>) {
    this.id = init?.id!;
    this.condominiumId = init?.condominiumId!;
    this.lockerId = init?.lockerId!;
    this.vendor = init?.vendor!;
  }
}
